import "./Jumbotron.css";
import NotePad from "../../assets/icons/note-board.svg";
import SelectPlanIcon from "../../assets/icons/select-plan.svg";
import ManagementIcon from "../../assets/icons/management.svg";
import styled from "styled-components";
import MediaQuery, { useMediaQuery } from "react-responsive";

const JumbotronOuterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* height: 270px; */
  width: 100%;
  max-width: 1303px;

  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

const JumbotronContainer = styled.div`
  height: 150px;
  width: 390px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media (max-width: 992px) {
    margin: 20px 0 20px 0;
  }
`;

const ImageContainer = styled.div``;

const TextContainer = styled.div`
  width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Text = styled.p`
  * {
    margin: 0;
    padding: 0;
  }

  font-size: ${(props: { size: any }) => props.size || "16px"};
  font-weight: ${(props: { fontWeight: any }) => props.fontWeight || "400"};
  color: ${(props: { color: any }) => props.color || "#fff"};
  font-family: ${(props: { font: any }) => props.font || "Poppins"};
  margin-bottom: ${(props: { marginBottom: any }) =>
    props.marginBottom || "0px"};
  margin-top: ${(props: { marginTop: any }) => props.marginTop || "0px"};
  letter-spacing: ${(props: { letterSpacing: any }) =>
    props.letterSpacing || "0px"};
`;

function Jumbotron() {
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  return (
    <div className="jumbotron">
      <JumbotronOuterContainer>
        <JumbotronContainer>
          <ImageContainer>
            <img className="jumbotron-item-img" src={NotePad} alt="" />
          </ImageContainer>
          <TextContainer>
            <Text
              size="20px"
              font="Poppins Medium"
              color="#fff"
              fontWeight="600"
              marginBottom="30px"
            >
              1. Sign Up
            </Text>
            <Text size="17px" font="Poppins Regular" color="#fff">
              Create an account and gain access to our platform
            </Text>
          </TextContainer>
        </JumbotronContainer>
        <JumbotronContainer>
          <ImageContainer>
            <img className="jumbotron-item-img" src={SelectPlanIcon} alt="" />
          </ImageContainer>
          <TextContainer>
            <Text
              size="20px"
              font="Poppins Medium"
              color="#fff"
              fontWeight="600"
              marginBottom="30px"
            >
              2. Select a Plan
            </Text>
            <Text size="17px" font="Poppins Regular">
              Select the plan right for you and schedule equipment installation
              by our technical team
            </Text>
          </TextContainer>
        </JumbotronContainer>
        <JumbotronContainer>
          <ImageContainer>
            <img className="jumbotron-item-img" src={ManagementIcon} alt="" />
          </ImageContainer>
          <TextContainer>
            <Text
              size="20px"
              font="Poppins Medium"
              color="#fff"
              fontWeight="600"
              marginBottom="30px"
            >
              3. Gain Access
            </Text>
            <Text size="17px" font="Poppins Regular">
              You’re all set! Manage/setup smart airbnb and self-checkin
              credentials for guests
            </Text>
          </TextContainer>
        </JumbotronContainer>
      </JumbotronOuterContainer>
    </div>
  );
}

export default Jumbotron;
